import React from 'react'
import { Link } from 'react-router-dom'

export default function DeckHeader() {
  return (
    <div className='flex items-end justify-end px-2 py-4'>
        <Link className='mr-4 text-blue-400' to ="/deck">Home</Link>
        <Link className='mr-4 text-blue-400' to="/deck/privacy" >Privacy</Link>
        <Link className='mr-4 text-blue-400' to="/deck/terms">Terms</Link>
    </div>
  )
}
